import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "@/shared/utils/baseQuery";

import { Tarif } from "@/widgets";

type GetServicesResponse = {
  services: Tarif[]
}

type CreatePaymentRequest = {
  service_id: number;
};

type CreatePaymentResponse = {
  payment_url: string | null;
  service_id: number;
  redirect_url?: string;
};

export const paymentsApi = createApi({
  reducerPath: "paymentsApi",
  baseQuery: createBaseQuery("https://api.fitkeep.ru/"),
  endpoints: (builder) => ({
    createPayment: builder.mutation<CreatePaymentResponse, CreatePaymentRequest>({
      query: (paymentData) => ({
        url: "/payments/create",
        method: "POST",
        body: paymentData,
      }),
    }),
    getServices: builder.mutation<GetServicesResponse, void>({
      query: () => ({
        url: "/payments/services",
        method: "POST",
        body: {},
      }),
    }),
  }),
});

export const { useCreatePaymentMutation, useGetServicesMutation } = paymentsApi;
